import type {
  NavHistoryEntry,
  NavHistoryListener,
} from "./nav-history-store.types";

export type { NavHistoryEntry } from "./nav-history-store.types";

const MAX_ENTRIES = 50;

let snapshot: NavHistoryEntry[] = [];
const listeners = new Set<NavHistoryListener>();

function notify(): void {
  listeners.forEach((l) => l());
}

export function subscribeNavHistory(listener: NavHistoryListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getNavHistory(): NavHistoryEntry[] {
  return snapshot;
}

export function clearNavHistory(): void {
  snapshot = [];
  notify();
}

export function addNavEntry(pathname: string): void {
  const safePathname = pathname.split(/[?#]/, 1)[0] || "/";
  // Don't duplicate consecutive identical paths
  if (snapshot.length > 0 && snapshot[0]?.pathname === safePathname) return;
  snapshot = [
    {
      id: Math.random().toString(36).slice(2),
      pathname: safePathname,
      timestamp: Date.now(),
    },
    ...snapshot,
  ].slice(0, MAX_ENTRIES);
  notify();
}
